import { defineComponent, resolveComponent, openBlock, createBlock, withCtx, createElementVNode, normalizeClass, renderSlot } from "vue";
import { getPrefixCls } from "../_utils/global-config.js";
import Trigger from "../trigger/index.js";
import _export_sfc from "../_virtual/plugin-vue_export-helper";
const _sfc_main = defineComponent({
  name: "Dsubmenu",
  components: {
    ATrigger: Trigger
  },
  setup() {
    const prefixCls = getPrefixCls("dropdown");
    return {
      prefixCls
    };
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_trigger = resolveComponent("a-trigger");
  return openBlock(), createBlock(_component_a_trigger, {
    trigger: "hover",
    position: "rt"
  }, {
    content: withCtx(() => [
      createElementVNode("div", {
        class: normalizeClass([`${_ctx.prefixCls}`, `${_ctx.prefixCls}-submenu`])
      }, [
        createElementVNode("ul", {
          class: normalizeClass(`${_ctx.prefixCls}-list`)
        }, [
          renderSlot(_ctx.$slots, "content")
        ], 2)
      ], 2)
    ]),
    default: withCtx(() => [
      createElementVNode("li", {
        class: normalizeClass(`${_ctx.prefixCls}-option`)
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2)
    ]),
    _: 3
  });
}
var _DropdownSubmenu = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export { _DropdownSubmenu as default };
